import { Zap } from 'lucide-react';

/** Marks a job with no agreed time; its date is only a placeholder until scheduled or completed. */
export function AsapBadge({ className = '' }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 w-fit ${className}`}
      title="ASAP — no scheduled time"
    >
      <Zap className="h-3 w-3" />
      ASAP
    </span>
  );
}
